// extracted by mini-css-extract-plugin
export var contact = "style-module--contact--174a9";
export var contactPerson = "style-module--contactPerson--db59a";